import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { withAuth } from '../../hoc/Auth';
import Api from '../../Api';
import Empty from './Empty';
import TableRow from './TableRow';
import ProjectMobileCard from '../ProjectMobileCard';
import Loader from '../Utils/Loader';
import Help from '../Utils/Help';

import ErrorHandler from '../../Services/ErrorHandler';
import ApiResponseValidator from '../../Services/ApiResponseValidator';

import classes from './styles.module.css';

export default withAuth(({ token }) => {
    const [projects, setProjects] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const activeProjects = projects.filter((project) => project.status === 1);

    useEffect(() => {
        let cancelled = false;

        async function loadProjects() {
            try {
                if (!cancelled) {
                    setLoading(true);
                    setError(null);
                }

                const response = await new Api({ token }).getProjects();

                if (cancelled) return;

                if (!ApiResponseValidator.validateListResponse(response)) {
                    throw new Error('Invalid projects response');
                }

                setProjects(Array.isArray(response) ? response : []);
            } catch (err) {
                ErrorHandler.logError(err, { action: 'getProjects', context: 'widget' });
                if (!cancelled) {
                    setError('ProjectsWidget.error.load');
                    setProjects([]);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        loadProjects();
        return () => {
            cancelled = true;
        };
    }, [token]);

    return (
        <div className={classes.Card}>
            <div className={classes.Header}>
                <h5>
                    <FormattedMessage id="ProjectsWidget.title" defaultMessage="Проекты" />
                </h5>
            </div>

            {loading ? (
                <Loader />
            ) : error ? (
                <div
                    style={{
                        padding: '16px',
                        backgroundColor: '#2c1414',
                        border: '1px solid #8b5555',
                        borderRadius: '4px',
                        color: '#ff9999',
                        textAlign: 'center',
                    }}
                >
                    <FormattedMessage id={error} defaultMessage="Не удалось загрузить проекты" />
                </div>
            ) : (
                <div className={classes.TableScroll}>
                    <table className={classes.Table}>
                        <thead>
                            <tr>
                                <th className={classes.CellLeft}>
                                    <FormattedMessage id="ProjectsWidget.table.project" defaultMessage="Проект" />
                                </th>
                                <th>
                                    <FormattedMessage id="ProjectsWidget.table.website" defaultMessage="Сайт" />
                                </th>
                                <th>
                                    <FormattedMessage id="ProjectsWidget.table.balance" defaultMessage="Баланс" />
                                </th>
                                <th>
                                    <FormattedMessage id="ProjectsWidget.table.payments" defaultMessage="Платежи" />
                                    <Help marginTop={3} marginLeft={5} placement="bottom">
                                        <FormattedMessage id="ProjectsWidget.help.avgBill" defaultMessage="Средний чек" />
                                    </Help>
                                </th>
                                <th>
                                    <FormattedMessage id="ProjectsWidget.table.payouts" defaultMessage="Выплаты" />
                                    <Help marginTop={3} marginLeft={5} placement="bottom">
                                        <FormattedMessage id="ProjectsWidget.help.avgBill" defaultMessage="Средний чек" />
                                    </Help>
                                </th>
                                <th />
                            </tr>
                        </thead>

                        <tbody>
                            {Boolean(activeProjects.length) ? (
                                activeProjects.map((project) => <TableRow key={project.uuid} data={project} />)
                            ) : (
                                <Empty />
                            )}
                        </tbody>
                    </table>

                    <div className={classes.MobileList}>
                        {Boolean(activeProjects.length) ? (
                            activeProjects.map((project) => <ProjectMobileCard key={project.uuid} data={project} />)
                        ) : (
                            <div className={classes.MobileEmpty}>
                                <FormattedMessage id="ProjectsWidget.empty.title" defaultMessage="Нет активных проектов" />
                            </div>
                        )}
                    </div>
                </div>
            )}

            <div className={classes.Footer}>
                <Link className={classes.Link} to={'/projects'}>
                    <FormattedMessage id="ProjectsWidget.link.viewAll" defaultMessage="Посмотреть все" />
                </Link>
            </div>
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/Components/ProjectsWidget/index.js